/** @format */

import React, { useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import UploadPrefixFile from './UploadPrefixFile';
import UploadPrefixFileList from './UploadPrefixFileList';

const PrefixesUploadList: React.FC = () => {
    const [reload, setReload] = useState<boolean>(false);

    useEffect(() => {
        if (reload) {
            setReload(false);
        }
    }, [reload]);

    return (
        <GridContainer spacing={1}>
            <GridItem xs={12}>
                <UploadPrefixFile reload={reload} setReload={setReload} />
            </GridItem>
            <GridItem xs={12}>
                <UploadPrefixFileList reload={reload} setReload={setReload} />
            </GridItem>
        </GridContainer>
    );
};

export default PrefixesUploadList;
